import lazyComponent from '../../../../utils/lazyComponent';
import { FilterModalProps } from '../../types/FilterModalProps';

const FilterModal = lazyComponent<FilterModalProps>(
  () => import('./FilterModal')
);

export default FilterModal;
